<template>
  <tr>
    <td>{{ size.id }}</td>
    <td>{{ size.min_width | milimeter }}</td>
    <td>{{ size.max_width | milimeter }}</td>
    <td>{{ size.min_height | milimeter }}</td>
    <td>{{ size.max_height | milimeter }}</td>
    <td>{{ size.thickness | milimeter }}</td>
    <td>
      <div class="controls">
        <nuxt-link
          :to="localePath({ name: 'office-industries-id-glass-sizes-size-edit', params: { size: size.id }})"
          class="button is-link is-small"
        >
          <span class="mdi mdi-pencil"></span>
        </nuxt-link>
        <button
          class="button is-danger is-small m-l-3"
          @click="removeSize"
          :class="{ 'is-loading': removing }"
        >
          <i class="mdi mdi-trash-can-outline"></i>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: ["size"],

  data() {
    return {
      removing: false
    };
  },

  methods: {
    async removeSize() {
      if (confirm(this.$t("message.are_you_sure"))) {
        this.removing = true;

        const { data } = await this.$api.deleteGlassDimension(
          this.$route.params.id,
          this.size.id
        );

        this.removing = false;
        this.$store.commit("industries/SET_GLASS_SIZES", {
          id: this.$route.params.id,
          data
        });
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// resources/nuxt/components/Industry/GlassSize.vue